export const COMMENT_MODEL = "comment";

const commentModel = {
  body: "",
  createdAt: "",
  updatedAt: "",
  commentableType: "",
  commentableId: "",
  attachments: [],
  notifyListeners: false,
  author: {
    jsonApi: "hasOne",
    type: "user"
  }
};

export default commentModel;
